import {LogFunc} from '../types';
import logConsole from './logConsole';

const log: LogFunc = async (level, message, data) => {
    if (level === 'error') logConsole(level, message, data);
};

export default log;
